import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/App";
import { useLocale } from "@/i18n/LocaleContext";
import { PartyPopper, ChevronRight } from "lucide-react";

export default function EventsPromoBanner() {
  const navigate = useNavigate();
  const { t, lang } = useLocale();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get("/events").then((r) => setEvent(r.data.events?.[0] || null)).catch(() => {});
  }, []);

  if (!event) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/events")}
      className="w-full flex items-center gap-3 p-4 mb-6 rounded-2xl text-left bg-gradient-to-r from-rose-600/15 via-fuchsia-600/10 to-amber-500/15 border border-rose-500/30 hover:border-rose-400/50 transition-colors"
      data-testid="events-promo-banner"
    >
      <span className="w-10 h-10 shrink-0 rounded-full bg-rose-500/15 border border-rose-500/40 flex items-center justify-center">
        <PartyPopper className="w-5 h-5 text-rose-400" />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block font-semibold text-sm">{t("events.bannerTitle")}</span>
        <span className="block text-xs text-muted-foreground truncate">
          {event.title} · {new Date(event.date_time).toLocaleDateString(lang, { dateStyle: "medium" })}
        </span>
      </span>
      <span className="shrink-0 inline-flex items-center gap-1 text-xs font-medium text-rose-400">
        {t("events.bannerCta")} <ChevronRight className="w-3.5 h-3.5" />
      </span>
    </button>
  );
}
